import { ReactElement } from 'react'
import { Link } from 'react-router'

import paths from '../../constants/paths'
import { CompanyReducer } from '../../reducers/companies'
import { GlobalMessageReducer } from '../../reducers/globalMessage'
import { WarningReducer } from '../../reducers/warnings'
import { formatDate } from '../../utils/date-utils'
import { t, tx } from '../../utils/translation-utils'
import Button from '../elements/button/button'
import jsBrowserHistory from '../widgets/jsBrowserHistory'

type Props = {
  companies: CompanyReducer
  globalMessage: GlobalMessageReducer
  warnings: WarningReducer
}

export default function GlobalMessage(props: Props): ReactElement | null {
  const content: ReactElement[] = []
  if (props.globalMessage.message) {
    content.push(<div className="global-message">{props.globalMessage.message}</div>)
  }
  if (props.companies.company?.isPayrollLocked) {
    content.push(
      <div className="global-message">
        {tx('header.warning.is_payroll_locked', {
          link: (
            <Link to={'/' + paths.COMPANIES + '/' + props.companies.company.id + '/invoices'}>
              {t('header.warning.is_payroll_locked.link')}
            </Link>
          ),
        })}
      </div>
    )
  }
  const imminentLockWarnings = props.warnings.warnings.filter((w) => w.warningType === 'ImminentPayrollLock')
  const earliestLockDate = imminentLockWarnings
    .map((w) => {
      try {
        return (JSON.parse(w.parameter) as { LockDate: string }).LockDate
      } catch {
        return null
      }
    })
    .filter((d): d is string => d !== null)
    .sort()
    .first(null)
  if (earliestLockDate && props.companies.company && !props.companies.company.isPayrollLocked) {
    const lockDateFormatted = formatDate(earliestLockDate)
    const invoicesPath = '/' + paths.COMPANIES + '/' + props.companies.company.id + '/invoices'
    content.push(
      <div className="global-message global-message-warning">
        {tx('header.warning.imminent_payroll_lock', {
          lockDate: lockDateFormatted,
          link: (
            <Button type="secondary" onClick={() => jsBrowserHistory.push(invoicesPath)}>
              {t('header.warning.imminent_payroll_lock.link')}
            </Button>
          ),
        })}
      </div>
    )
  }
  return <>{content.map((e) => e)}</>
}
